import React, {useEffect} from "react";
import { Helmet } from "react-helmet";
import { useParams, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
// import Container from '@mui/material/Container';

import {
  formatProviderName,
  isPersonalTrainer
} from "../../helpers/providers";
import { setVisitorUUID } from "../../redux/reducers/analytics";
import { useGetProvidersQuery } from "../../redux/services/providerApi";
import { useCreateVisitorMutation } from "../../redux/services/visitorApi";
import BookingForm from "../../components/booking/BookingFromPublicProviderProfileForm";
import PatientSignupLayout from "../../components/patientSignup/PatientSignupLayout/PatientSignupLayout";

const trackVisitor = async ({
  createVisitor, 
  saveVisitorUUID, 
  providerId,
  slug
}) => {
  let body = {
    scheduling_step: 'SELECTED_SEARCH_METHOD',
    search_method: 'FROM_PROVIDER_PROFILE',
    did_find_providers: true,
  };
  if (providerId) body.provider_id = providerId;
  if (slug) body.provider_slug = slug;
  const response = await createVisitor(body);
  if (response?.data) saveVisitorUUID(response.data.uuid);
};

const PublicBookingWithProviderPage = props => {
  const {provider, metaTitle, metaDescription} = props;
  const borderRadius = '16px';
  const boxStyles = {
    borderRadius, 
    minHeight: '70vh',
    // px: 2,
  };
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name='description'content={metaDescription} />
        {/*<link rel="canonical" href="http://mysite.com/example" />*/}
      </Helmet>
      <PatientSignupLayout
        {...props}
        backgroundColor='#424751'
        stepTitle={`Schedule a session`}
      >
        <Box
          style={{
            marginTop: '0em',
            // paddingTop: stepIndex === 0 ? '2em' : '0em',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: borderRadius,
            backgroundColor: '#ffffff',
            border: '1px solid rgb(240,240,240)',
          }}
        >
          <BookingForm
            provider={provider}
            boxStyles={boxStyles}
            useVisitorTracking={true}
            hideFirstStep={props.hideFirstStep}
          />
        </Box>
      </PatientSignupLayout>
    </>
  );
};

PublicBookingWithProviderPage.defaultProps = {
  metaTitle: 'Book a Session with a MovementX Provider',
  metaDescription: 'Schedule your first session with a MovementX provider. Choose from our specialized services and book your appointment today.',
};

const PublicBookingWithProviderPageContainer = props => {
    const {id, slug} = useParams();
    const [search] = useSearchParams();
    const hideFirstStep = search.get('skipAccountStep') === 'true';
    const [createVisitor] = useCreateVisitorMutation();
    const uuid = props?.uuid || null;
    const providerQuery = useGetProvidersQuery(
      (
        slug
        ? {slug, is_hidden: false}
        : {id, is_hidden: false}
      ),
      {refetch: true, skip: false}
    );
    useEffect(() => {
      if (!uuid) {
        trackVisitor({
          saveVisitorUUID: props.saveVisitorUUID, 
          createVisitor,
          slug,
          providerId: id,
        });
      }
    }, []);
    const provider = (providerQuery?.data || [])?.[0] || null;
    const providerName = formatProviderName(provider);
    const city = provider?.primary_location || '';
    const providerType = isPersonalTrainer(provider) ? 'Personal Trainer' : 'Physical Therapist';
    const childProps = {
      provider,
      metaTitle: (
        provider 
        ? `Schedule with ${providerName} - MovementX ${providerType} in ${city}`
        : `Schedule an appointment with ${providerName}, a MovementX ${providerType} in ${city}.`
      ),
      metaDescription: provider ? `Schedule your first session with ${provider.first_name} ${provider.last_name}, a MovementX provider. Choose from our specialized services and book your appointment today.` : 'Schedule your first session with a MovementX provider. Choose from our specialized services and book your appointment today.',
      hideFirstStep,
    };
    return <PublicBookingWithProviderPage {...childProps} />;
};

const mapState = state => ({
  uuid: state?.analytics?.visitorUUID,
});

const mapDispatch = dispatch => ({
  saveVisitorUUID: uuid => dispatch(setVisitorUUID(uuid)),
});

export default connect(mapState, mapDispatch)(PublicBookingWithProviderPageContainer);